import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './CostsDatesProposal.css';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import Number from 'components/shared/text/Number';
import numeral from 'numeral';
import { updateCompletionDate } from 'actions/admin/work-orders/details/proposal';
import { updateCOCompletionDate } from 'components/admin/work-orders/details/change-orders/store/actions';

class CostsDatesProposal extends Component {
  handleCompletionDateChange = (value) => {
    if (this.props.isChangeOrder) {
      this.props.dispatch(updateCOCompletionDate(value));
    } else {
      this.props.dispatch(updateCompletionDate(value));
    }
  };

  render() {
    const props = this.props;
    const showTotalBorder =
      props.startDate !== null ||
      props.completionDate !== null ||
      props.cost !== null;
    return (
      <div className="costs-totals-container">
        {props.isChangeOrder ? (
          <div>
            <div
              className={'ctc-row' + (showTotalBorder ? ' with-border' : '')}
            >
              <div>CHANGE ORDER AMOUNT</div>
              <div className="cost-value">
                <Number value={props.total} format="$0,0" />
              </div>
            </div>
            <div
              className={'ctc-row' + (showTotalBorder ? ' with-border' : '')}
            >
              <div>PREVIOUS CONTRACT AMOUNT</div>
              <div className="cost-value">
                <Number value={props.previousCost} format="$0,0" />
              </div>
            </div>
            <div
              className={'ctc-row' + (showTotalBorder ? ' with-border' : '')}
            >
              <div className="orange">NEW CONTRACT AMOUNT</div>
              <div className="total-value">
                <Number
                  value={props.previousCost + numeral(props.total).value()}
                  format="$0,0"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={'ctc-row' + (showTotalBorder ? ' with-border' : '')}>
            <div className="orange">TOTAL</div>
            <div className="total-value">
              <Number value={props.total} format="$0,0" />
            </div>
          </div>
        )}
        {props.startDate !== null && (
          <div className="ctc-row">
            <div>Start Date</div>
            <div>
              <DatetimePicker
                format="M/D/YYYY"
                placeholder=""
                readOnly={true}
                value={props.startDate}
                onChange={() => {}}
              />
            </div>
          </div>
        )}
        {props.completionDate !== null && (
          <div
            className={`ctc-row ${
              props.completionDate.editable ? 'without-padding' : ''
            }`}
          >
            <div className={props.completionDate.editable ? 'orange' : null}>
              Completion Date
            </div>
            <div>
              <DatetimePicker
                format="M/D/YYYY"
                placeholder=""
                readOnly={!props.completionDate.editable}
                value={props.completionDate.value}
                onChange={this.handleCompletionDateChange}
              />
            </div>
          </div>
        )}
        {props.cost !== null && (
          <div className="ctc-row with-border">
            <div>COST</div>
            <div className="cost-value">
              <Number value={props.cost} format="$0,0" />
            </div>
          </div>
        )}
      </div>
    );
  }

  static propTypes = {
    completionDate: PropTypes.shape({
      editable: PropTypes.bool,
      value: PropTypes.string,
    }),
    cost: PropTypes.number,
    startDate: PropTypes.string,
    total: PropTypes.number.isRequired,
    onCompletionDateChange: PropTypes.func,
  };

  static defaultProps = {
    completionDate: null,
    cost: null,
    startDate: null,
  };
}

export default connect()(CostsDatesProposal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/CostsDatesProposal.js